module.exports = __webpack_public_path__ + "img/iphone_2.ccb00d37.png";